import {InjectionKey} from 'vue';

export type DropdownContext = {
	close: () => void;
};

export const DROPDOWN: InjectionKey<DropdownContext> = Symbol('hf-dropdown');
